/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import ComponentView from '../base/ComponentView';
import dashboardMessageBus from '../../dashboardMessageBus';
import dashboardMessageBusEvents from '../../enum/dashboardMessageBusEvents';
import dashboardComponentTypes from '../../enum/dashboardComponentTypes';
import ContextMenu from 'js-sdk/src/common/component/menu/ContextMenu';
import _ from 'underscore';
import $ from 'jquery';
import i18n from '../../../i18n/DashboardBundle.properties';
import PropertiesPanelView from '../../view/designer/propertiesDialog/view/PropertiesPanelView';

export default ComponentView.extend({
    events: _.extend({}, ComponentView.prototype.events, {
        'click': '_selectComponent',
        'mouseover': '_hoveredComponent',
        'mouseout': '_mouseoutComponent',
        'contextmenu': '_showContextMenu'
    }),
    initialize: function () {
        ComponentView.prototype.initialize.apply(this, arguments);
        this._initContextMenu();
        if (this.model.get('type') !== dashboardComponentTypes.FILTER_GROUP) {
            this.addOverlay();
        }
        this.on('componentRendered', _.bind(this._onComponentRendered, this));
        this.listenTo(this.model, 'change:selected', this._onComponentSelect);
        this.listenTo(this.model, 'change:hovered', this._onComponentHovered);
        this.listenTo(dashboardMessageBus, dashboardMessageBusEvents.TOGGLE_PREVIEW_MODE, _.bind(this._onTogglePreviewMode, this));
        this.listenTo(this.dashboardProperties, 'change', this._onDashboardPropertiesChange);
    },
    remove: function () {
        this.propertiesDialogController && this.propertiesDialogController.remove();
        ComponentView.prototype.remove.apply(this, arguments);
    },
    _initContextMenu: function () {
        var contextMenuOptions = [
            {
                label: i18n['dashboard.context.menu.option.delete'],
                action: 'delete'
            }
        ];
        if (this.additionalContextMenuOptions) {
            contextMenuOptions = contextMenuOptions.concat(this.additionalContextMenuOptions);
        }
        this.contextMenu = new ContextMenu(contextMenuOptions, {hideOnMouseLeave: true});
        this.listenTo(this.contextMenu, 'option:properties', this._showPropertiesDialog);
        this.listenTo(this.contextMenu, 'option:delete', this._deleteComponent);
        this._initComponentSpecificContextMenuEvents && this._initComponentSpecificContextMenuEvents();
    },
    _onTogglePreviewMode: function (previewIsOn) {
        if (this.propertiesDialogController && this.propertiesDialogController.dialog) {
            var dialog = this.propertiesDialogController.dialog;
            var coordinates = this.propertiesDialogController.lastCoordinates;
            this.propertiesDialogController.dialogIsOpened && !previewIsOn ? dialog.open(_.extend({silent: true}, coordinates)) : dialog.close({silent: true});
        }
    },
    _onComponentRendered: function () {
    },
    _onComponentHovered: function() {
        if (this.model.get('hovered')) {
            this.$el.addClass('hovered');
        } else {
            this.$el.removeClass('hovered');
        }
    },
    _onComponentSelect: function () {
        if (this.model.get('selected')) {
            this.$el.addClass('selected');
            this.$el.trigger('click');
        } else {
            this.$el.removeClass('selected');
            this.contextMenu.hide();
        }
    },
    _onDashboardPropertiesChange: function (model) {
    },
    _deleteComponent: function () {
        this.trigger('delete', this.model);
    },
    _hoveredComponent: function(e) {
        e && e.stopPropagation && e.stopPropagation();
        this.model && this.model.collection && this.model.collection.hoverComponent($(e.target).attr('id') || this.model.id);
    },
    _mouseoutComponent: function(e) {
        e && e.stopPropagation && e.stopPropagation();
        this.model && this.model.collection && this.model.collection.hoverOut($(e.target).attr('id') || this.model.id);
    },
    _selectComponent: function (e) {
        e && e.stopPropagation && e.stopPropagation();
        this.model && this.model.collection && this.model.collection.selectComponent($(e.target).attr('id') || this.model.id);
        if (!this.propertiesPanel) {
            this.propertiesPanel = new PropertiesPanelView({model : this.model});
        }
    },
    _showContextMenu: function (e) {
        e.preventDefault();
        this._selectComponent(e);
        this.contextMenu.show({
            left: e.pageX,
            top: e.pageY
        }, this.$el);
    }
});